// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueI18n from 'vue-i18n'

Vue.config.productionTip = false
Vue.use(VueI18n)

Vue.getCookieByName = Vue.prototype.getCookieByName = function(name){
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
 
    if(arr=document.cookie.match(reg))
 
        return unescape(arr[2]); 
    else 
        return null; 
}
let lan = Vue.getCookieByName("lan");
if(!lan){
  lan = "en";
}

const i18n = new VueI18n({
  locale:lan,
  messages:{
    'zh':require('./assets/common/zh.js'),
    'en':require('./assets/common/en.js')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js